/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import { isEmpty } from 'lodash'

import { Filters } from 'components'

import helpers from 'helpers'

const DepartmentFilter = ({ filter }) => {
  const { filters, drawerOpen } = filter

  const [companies, setCompanies] = useState([])
  const [companyInputValue, setCompanyInputValue] = useState('')
  const [isLoadingCompaniesInput, setIsLoadingCompaniesInput] = useState(false)
  const [isLoadingCompanies, setIsLoadingCompanies] = useState(false)

  const {
    loadCompanies,
    mountCompanyParams,
    instructionsText: companyText,
  } = helpers.companies.typeAndSearch

  const handleTypeCompaniesInput = (e) => {
    setCompanyInputValue(e.target.value)
  }

  const [users, setUsers] = useState([])
  const [userInputValue, setUserInputValue] = useState('')
  const [isLoadingUsersInput, setIsLoadingUsersInput] = useState(false)

  const {
    loadUsers,
    mountUsersParams,
    instructionsText: userText,
  } = helpers.users.typeAndSearch

  const handleTypeUsersInput = (e) => {
    setUserInputValue(e.target.value)
  }

  const { nameWithDocumentByArrayObject } = helpers.companies.nameWithDocument
  const companiesOptionsValues = nameWithDocumentByArrayObject(
    isLoadingCompaniesInput ? [] : companies,
  )

  useEffect(() => {
    const getCompanies = setTimeout(() => {
      const hasCompanyValueToFetch =
        companyInputValue.length < 3 && isEmpty(filters?.companyId)

      if (hasCompanyValueToFetch || !drawerOpen) return

      loadCompanies(
        mountCompanyParams(companyInputValue, filters),
        setIsLoadingCompaniesInput,
        setCompanies,
      )
    }, 1000)

    return () => clearTimeout(getCompanies)
  }, [companyInputValue])

  useEffect(() => {
    const getUsers = setTimeout(() => {
      const hasUserValueToFetch =
        userInputValue.length < 3 && isEmpty(filters?.userId)

      if (hasUserValueToFetch || !drawerOpen) return

      loadUsers(
        mountUsersParams(userInputValue, filters),
        setIsLoadingUsersInput,
        setUsers,
      )
    }, 1000)

    return () => clearTimeout(getUsers)
  }, [userInputValue])

  useEffect(() => {
    if (filters?.companyId) {
      loadCompanies(
        mountCompanyParams(companyInputValue, filters),
        setIsLoadingCompanies,
        setCompanies,
      )
    }
  }, [filters?.companyId])

  useEffect(() => {
    if (!drawerOpen) {
      if (companyInputValue) setCompanyInputValue('')
      if (userInputValue) setUserInputValue('')
    }
  }, [drawerOpen])

  return (
    <Filters filter={filter} isLoading={isLoadingCompanies}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Nome do departamento" name="name" />
      <select
        autocompleteselectinput="true"
        label="Empresa"
        name="companyId"
        loading={isLoadingCompaniesInput}
        onChangeTypeSearch={handleTypeCompaniesInput}
        optionvalues={companiesOptionsValues}
        noOptionsText={companyText(companyInputValue)}
      />
      <select
        autocompleteselectinput="true"
        label="Usuário"
        name="userId"
        loading={isLoadingUsersInput}
        onChangeTypeSearch={handleTypeUsersInput}
        optionvalues={users}
        noOptionsText={userText(userInputValue)}
      />
    </Filters>
  )
}

export default DepartmentFilter
